import * as global from "./global";
import * as users from "./users";
import * as customers from "./customers";
import * as persongroups from "./persongroups";
import * as persons from "./persons";
import * as agreements from "./agreements";
import * as orders from "./orders";
import * as products from "./products";
import * as productpackages from "./productpackages";

export const types = Object.assign(
	{},
	global,
	users,
	customers,
	persongroups,
	persons,
	agreements,
	orders,
	products,
	productpackages
);